import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { DashboardLocalService } from '../../services/dashboard/dashboard-local.service';
import * as HighCharts from 'highcharts';
import Bullet from 'highcharts/modules/bullet';
import { InboxService } from '../../services/inbox.service';
import { PiwikProUtils } from '../../common/utility/piwikProUtils';
import { UserDataService } from '../../services/user-data.service';



import Exporting from 'highcharts/modules/exporting';
import OfflineExporting from 'highcharts/modules/offline-exporting';
import ExportData from 'highcharts/modules/export-data';
import CustomEvents from 'highcharts-custom-events';

function applyHighchartsModule(module, Highcharts) {
  if (typeof module === 'function') {
    module(Highcharts);
  } else if (module && typeof module.default === 'function') {
    module.default(Highcharts);
  }
}

applyHighchartsModule(Exporting, HighCharts);
applyHighchartsModule(Bullet, HighCharts);
applyHighchartsModule(OfflineExporting, HighCharts);
applyHighchartsModule(ExportData, HighCharts);
applyHighchartsModule(CustomEvents, HighCharts);

@Component({
  selector: 'app-intensity-heatmap-bullet',
  templateUrl: './intensity-heatmap-bullet.component.html',
  styleUrls: ['./intensity-heatmap-bullet.component.scss']
})
export class IntensityHeatmapBulletComponent implements OnInit {
  heatmapData: any;
  chartData: any;
  protected heatmapChart: any;
  public data: any;
  public heatmapOptions: any;
  totalInquiry: number = 0;
  @Input() iHeatmapData: any;
  constructor(private userDataService: UserDataService, private inboxService: InboxService, private dashboardService: DashboardService, private localService: DashboardLocalService) { }
  ngOnInit(): void {
    this.data = this.iHeatmapData;
    if (this.data) {
    if (!this.data['intensityHeatMap'] || !Array.isArray(this.data['intensityHeatMap'])) {
      console.error('Invalid data:', this.data);
      return;
    }
    this.totalInquiry = 0;
    this.chartData = this.data['intensityHeatMap'].map((item, index) => {
      const category = Object.keys(item).find(key => key !== 'colorCode' && key !== 'tagLimit');
      this.totalInquiry += item[category]
      return {
        name: category,
        y: Object.values(item)[0], // Extract numeric value
        target: parseInt(item.tagLimit, 10), // Target marker
        color: item.colorCode, // Custom colors
      }
    });
    this.chartData = this.chartData.map(item => ({
      ...item,
      totalInquiry: this.totalInquiry
    }));
    this.totalInquiry = this.chartData.reduce((sum, item) => sum + item.y, 0);
    this.renderMultipleCharts(this.chartData);
  }
}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['iHeatmapData']) {
      this.ngOnInit()
    }
  }
  renderMultipleCharts(chartData: any[]): void {
    const container = document.getElementById('intensity-heatmap');
    if (!container) {
      console.error('Chart container not found');
      return;
    }

    container.innerHTML = ''; // Clear existing charts


    const titleDiv = document.createElement('div');
    titleDiv.style.lineHeight = '21.79px';
    titleDiv.style.textAlign = 'left';
    titleDiv.style.fontSize = '16px';
    titleDiv.style.fontFamily = 'OpenSansBold';
    titleDiv.style.color = '#272727';
    titleDiv.style.paddingTop = '13px';
    titleDiv.style.paddingLeft = '25px';
    titleDiv.style.paddingBottom = '8px';
    titleDiv.innerText = 'Client Inquiry Monitor';

    // Create context menu button with custom icon
    const menuButton = document.createElement('div');
    menuButton.innerHTML = '<img src="assets/dashboard/context-menu.png" alt="Menu" style="width:25px;height:25px;">';
    menuButton.style.position = 'absolute';
    menuButton.style.top = '13px';
    menuButton.style.right = '25px';
    menuButton.style.cursor = 'pointer';
    menuButton.style.padding = '1px'; // Ensures the background applies evenly
    menuButton.style.borderRadius = '4px'; // Smooth corners
    menuButton.style.transition = 'background-color 0.2s'; // Smooth effect

    // Add hover effect
    menuButton.addEventListener('mouseenter', () => {
      menuButton.style.backgroundColor = '#e6e6e6'; // ✅ Apply background on hover
    });
    menuButton.addEventListener('mouseleave', () => {
      menuButton.style.backgroundColor = 'transparent'; // ✅ Reset on mouse leave
    });


    // Create context menu
    const contextMenu = document.createElement('div');
    contextMenu.style.position = 'absolute';
    contextMenu.style.top = '35px';
    contextMenu.style.right = '25px';
    contextMenu.style.background = '#fff';
    contextMenu.style.border = '1px solid #ccc';
    contextMenu.style.borderRadius = '4px';
    contextMenu.style.boxShadow = '0 2px 6px rgba(0,0,0,0.2)';
    contextMenu.style.display = 'none';
    contextMenu.style.zIndex = '1000';


    // Add menu items
    const menuItems = ['Print Chart', 'Download PNG image', 'Download JPEG image', 'Download PDF document', 'Download CSV', 'Maximize'];
    menuItems.forEach(item => {
      const menuItem = document.createElement('div');
      menuItem.innerText = item;
      menuItem.style.padding = '8px 16px';
      menuItem.style.cursor = 'pointer';
      menuItem.style.fontSize = '12px';
      menuItem.style.fontFamily = 'OpenSansLight';
      menuItem.addEventListener('click', () => {
        contextMenu.style.display = 'none';
        switch (item) {
          case 'Print Chart':
            window.print();
            break;
          case 'Download PNG image':
            this.localService.download("intensity-heatmap", "png");
            break;
          case 'Download JPEG image':
            this.localService.download("intensity-heatmap", "jpg");
            break;
          case 'Download PDF document':
            this.localService.download("intensity-heatmap", "pdf");
            break;
          case 'Download CSV':
            this.localService.download("intensity-heatmap", "csv")
            break;
          case 'Maximize':
            container.requestFullscreen();
            break;
          default:
            console.log(`${item} clicked`);
        }
      });
      menuItem.addEventListener('mouseenter', () => menuItem.style.backgroundColor = '#f0f0f0');
      menuItem.addEventListener('mouseleave', () => menuItem.style.backgroundColor = '');
      contextMenu.appendChild(menuItem);
    });

    // Toggle menu visibility
    menuButton.addEventListener('click', (event) => {
      event.stopPropagation();
      contextMenu.style.display = contextMenu.style.display === 'block' ? 'none' : 'block';
    });

    // Hide context menu when clicking outside
    document.addEventListener('click', () => {
      contextMenu.style.display = 'none';
    });

    // Append button and context menu
    titleDiv.appendChild(menuButton);
    titleDiv.appendChild(contextMenu);
    container.appendChild(titleDiv);

    let clickTimeout: any;

    chartData.forEach((dataPoint, index) => {
      const chartDiv = document.createElement('div');
      chartDiv.id = `bullet-chart-${index}`;
      chartDiv.style.width = '100%';
      chartDiv.style.height = '120px';
      chartDiv.style.marginBottom = '-10px';
      container.appendChild(chartDiv);
      const dynamicMax = Math.max(dataPoint.target * 1.2, 100);

      HighCharts.chart(chartDiv, {
        chart: {
          type: 'bullet',
          inverted: true,
          marginLeft: 25,
          marginRight: 25,
        },
        title: {
          useHTML: true,
          text: `<span style="line-height: 14.79px;font-size: 12px;margin-left:15px;font-family:\'OpenSansSemiBold\';color:'#272727';">${dataPoint.name}</span>`,
          align: 'left',

          style: {
             marginBottom:'-32px'
           }
        },
        xAxis: { visible: false },
        yAxis: {
          gridLineWidth: 0,
          plotBands: [
            { from: 0, to: 150, color: '#F3F4F8' },
            { from: 150, to: 225, color: '#F3F4F8' },
            { from: 225, to: 9e9, color: '#F3F4F8' }
          ],
          title: null,
          max: dynamicMax,
          maxPadding: 0.4,
        },
        legend: { enabled: false },
        plotOptions: {
          bullet: {
            pointPadding: 0.6,
            groupPadding: 0.8
          },
          series: {
            point: {
              events: {
                click: (event) => {
                  if (clickTimeout) {
                    clearTimeout(clickTimeout);
                    clickTimeout = null;
                    this.handleDoubleClick(dataPoint);
                  } else {
                    clickTimeout = setTimeout(() => {
                      clickTimeout = null;
                    }, 300);
                  }
                }
              }
            }
          }
        },
        series: [{
          type: 'bullet',
          data: [{
            y: dataPoint.y,
            target: dataPoint.target,
            color: dataPoint.color,
          }],
          targetOptions: {
            color: 'black'
          },
          pointWidth: 20,
          dataLabels: {
            enabled: true,
            style: { fontSize: '12px', fontFamily: 'OpenSansSemiBold' },
            formatter: function () { return this.y.toString(); },
          },
        }],
        tooltip: {
          backgroundColor: 'rgba(252,252,252,1)',
          formatter: function () {
            return `<b>${this.series.chart.userOptions.title.text}</b><br>
            Inquiries: ${this.y};&nbsp;&nbsp;&nbsp;Total: ${dataPoint.totalInquiry};&nbsp;&nbsp;&nbsp;Limit: ${dataPoint.target}`;
          }
        },
        exporting: {
          enabled: false,
          printMaxWidth: 1500,
          buttons: {
            contextButton: {
              symbol: 'url(assets/dashboard/context-menu.png)',
              symbolSize: 28,
              symbolX: 28,
              symbolY: 28,
              width: 28,
              height: 28
            }
          },
          csv: { decimalPoint: ':' }
        },
        credits: { enabled: false },
      });
    });
  }

  handleDoubleClick(point) {
    let idx = this.data.intensityHeatMap.findIndex(obj => {
      return Object.keys(obj).some(key => {
        return (key.toUpperCase() == point.name.toUpperCase());
      });
    });

    if (idx < 0) { return; }
    const groupName = this.data.intensityHeatMap[idx].hasOwnProperty('groupName') ? this.data.intensityHeatMap[idx].groupName : "";
    const categoryName = Object.keys(this.data.intensityHeatMap[idx])[0];
    const color = point.color;
    this.inboxService.startViewLoading({ color });
    this.inboxService.requestView({ viewName: "intensityHeatMap", categoryName: categoryName, groupName: groupName, type: 'intensityHeatmap' });

    PiwikProUtils.trackJsonDataForEvent(this.userDataService.loggedInUserInfo.pivotProConfigEnabled, this.userDataService.loggedInUserInfo.userId, "Dashboard", "Intensity Heat Map Bar", "Double Click", "Intensity Heat Map Bar", 4);
  }


}
